export default "__VITE_ASSET__BD6W11JK__"